import React, {ReactNode, useEffect} from 'react'
import {
    StyledOverlayStyled,
    StyledSheetContainer,
    StyledModalCloseSection,
    StyledModalTitle
} from '@components/ui/bottom-sheet/style.ts'
import {XCloseIcon} from '@components/ui/icon/Icon.tsx'
interface BottomSheetProps {
    isOpen: boolean
    onClose: () => void
    children: ReactNode
    title: string
}

export const BottomSheet: React.FC<BottomSheetProps> = ({isOpen, onClose, children, title}) => {
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden'
        } else {
            document.body.style.overflow = 'auto'
        }
        return () => {
            document.body.style.overflow = 'auto'
        }
    }, [isOpen])

    return (
        <>
            <StyledOverlayStyled $isOpen={isOpen} onClick={onClose} />
            <StyledSheetContainer $isOpen={isOpen}>
                <StyledModalCloseSection justify="flex-end">
                    <XCloseIcon onClick={onClose} />
                </StyledModalCloseSection>
                <StyledModalTitle>{title}</StyledModalTitle>
                {children}
            </StyledSheetContainer>
        </>
    )
}
